import { FC } from 'react';
import { Typography } from '@mui/material';

const Alerts: FC<React.PropsWithChildren<AlertsProps>> = props => {
  return (
    <Typography variant='body2' fontWeight={400} color='text.primary'>
      None
    </Typography>
  );
};

export interface AlertsProps {}

export default Alerts;
